
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, 
      retry: (failureCount, error) => {
        if (error?.status === 404 || error?.response?.status === 404) return false;
        return failureCount < 1;
      },
      staleTime: 10000,
      refetchInterval: false,
    },
  },
});

// The session snapshot (buildSessionCacheKey: ["session", id]) is only ever written by the
// cme-common sync (setQueryData) - no useQuery observes it, so React Query garbage-collected
// it gcTime (5 min) after the page loaded. Every live update after that found no base and
// was buffered, e.g. a cmestatus "3" never showed the Session Has Ended screen until a refresh.
queryClient.setQueryDefaults(["session"], { gcTime: Infinity });
